import { CSSProperties } from 'react';

import { Toaster as Sonner, ToasterProps } from 'sonner';

import { useDarkMode } from '../context/DarkmodeContext';

export const Toaster = ({ ...props }: ToasterProps) => {
  const { isDarkMode } = useDarkMode();
  const theme = isDarkMode ? 'dark' : 'light';

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      closeButton
      richColors
      duration={3000}
      position="top-right"
      style={
        {
          '--normal-bg': 'var(--color-bgSurfaceDefault)',
          '--normal-text': 'var(--color-textDefault)',
          '--normal-border': 'var(--color-borderDefault)',
        } as CSSProperties
      }
      {...props}
    />
  );
};
